import type { Conversation } from "@gumtree/shared/src/types/message-centre";
import { MessageCentreState } from ".";

export const selectActiveConversation = ({ messageCentre: { activeConversationId, conversations }}: MessageCentreState) => {
  if (!activeConversationId || !conversations[activeConversationId]) {
    return Object.values(conversations)[0];
  }

  return conversations[activeConversationId];
};

export const selectUnreadMessagesCount = ({ messageCentre: { conversations }}: MessageCentreState) => {
  const conversationList = Object.values(conversations) as Conversation[];

  if (!conversationList.length) {
    return 0;
  } 

  return conversationList.reduce((count, conversation) => count + conversation.unreadMessagesCount, 0)
}
